import React from "react";
import styles from "./Button.module.css";
import { Link } from "react-router-dom";

const Button = ({ children, onClick, type = "button", variant = "primary", className = "", to }) => {
  const btnClass = [styles.btn, styles[variant], className].filter(Boolean).join(" ");
  
  if (to) {
    return (
      <Link to={to} className={btnClass}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={btnClass}>
      {children}
    </button>
  );
};

export default Button;